import { yomiriDatabase } from './YomiriDatabase.ts';

export type DownloadDirectory = FileSystemDirectoryHandle & {
  queryPermission(options: { mode: 'readwrite' }): Promise<PermissionState>;
  requestPermission(options: { mode: 'readwrite' }): Promise<PermissionState>;
};

export async function chooseDownloadFolder(): Promise<string> {
  const picker = (window as unknown as { showDirectoryPicker?: (options: { mode: string; id: string; startIn: string }) => Promise<DownloadDirectory> }).showDirectoryPicker;
  if (!picker) throw new Error('Este navegador no permite elegir carpetas. Usá las descargas del navegador.');
  const parent = await picker.call(window, { mode: 'readwrite', id: 'yomiri-downloads', startIn: 'downloads' });
  const root = parent.name.toLowerCase() === 'yomiri' ? parent : await parent.getDirectoryHandle('Yomiri', { create: true });
  const name = parent.name.toLowerCase() === 'yomiri' ? 'Yomiri' : `${parent.name}/Yomiri`;
  await Promise.all([root.getDirectoryHandle('Manga', { create: true }), root.getDirectoryHandle('Anime', { create: true })]);
  await yomiriDatabase.setSetting('custom_directory_handle', root);
  await yomiriDatabase.setSetting('storage_folder_config', { mode: 'filesystem', directoryName: name, updatedAt: Date.now() });
  window.dispatchEvent(new Event('yomiri-downloads-changed'));
  return name;
}

export async function getDownloadFolder(): Promise<DownloadDirectory> {
  const root = await yomiriDatabase.getSetting<DownloadDirectory>('custom_directory_handle');
  if (!root) throw new Error('Elegí una carpeta de descargas para guardar el episodio.');
  const granted = await root.queryPermission({ mode: 'readwrite' }) === 'granted' ||
    await root.requestPermission({ mode: 'readwrite' }) === 'granted';
  if (!granted) throw new Error('Necesitás permitir el acceso a la carpeta de descargas.');
  return root;
}
